"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tank = void 0;
const DefinitionAndHelpers_1 = require("../../DefinitionAndHelpers");
const StorageTypes_1 = require("../../DefinitionAndHelpers/Definitions/StorageTypes");
const Storage_1 = require("./Storage");
const typeName = 'Tank';
//IAggregationFns
class Tank extends Storage_1.Storage {
    constructor(ob) {
        var _a;
        super({ ...ob, type: typeName });
        this.shape = ob.shape;
        this.forecastCollectionInSevenDays = (_a = ob.forecastCollectionInSevenDays) !== null && _a !== void 0 ? _a : null;
    }
    //Total Volume in Liters = 1000 x volume in m3
    get _totalVolume() {
        return this.height ? this._surfaceAreaM2 * this.height * 1000 : 0;
    }
    get _surfaceAreaM2() {
        return this.diameter ? Math.PI * Math.pow(this.diameter / 2, 2) : 0;
    }
    set reportedTankLevel(tankLevelM) {
        this._reportedTankLevel = tankLevelM;
        this.current_filled_volume = this._surfaceAreaM2 * this.reportedTankLevel * 1000;
    }
    get reportedTankLevel() {
        var _a;
        return (_a = this._reportedTankLevel) !== null && _a !== void 0 ? _a : 0;
    }
    fill(litersIn) {
        var _a;
        const _height = (_a = this.height) !== null && _a !== void 0 ? _a : 0;
        const heightIncrease = litersIn / this._surfaceAreaM2;
        this.reportedTankLevel = Math.min(this.reportedTankLevel + heightIncrease, _height * 1000);
    }
    drain(litersIn) {
        const heightDecrease = litersIn / this._surfaceAreaM2;
        this.reportedTankLevel = Math.max(this.reportedTankLevel - heightDecrease, 0);
    }
    get _circumference() {
        return this.diameter ? 2 * Math.PI * (this.diameter / 2, 2) : 0;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            functions: {
                type: 'Derived',
                valueFn: (state, functions, accessKey) => {
                    return { state, functions, accessKey, thisObject: this };
                },
                viewName: 'UIThingFunctions',
            },
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of tank',
            },
            purpose: {
                type: 'String',
                editable: true,
                label: 'Purpose',
                name: 'purpose',
                description: 'Used for',
            },
            capacity: {
                type: 'Number',
                editable: true,
                label: 'Capacity',
                name: 'capacity',
                description: 'Total storage capacity of tank in m3 and litres',
            },
            shape: {
                type: 'Enum',
                editable: true,
                label: 'Shape',
                name: 'shape',
                description: 'Cylinder, rectangle, other',
                enumKv: StorageTypes_1.TankShape,
            },
            constructionMaterial: {
                type: 'String',
                editable: true,
                label: 'Construction material',
                name: 'constructionMaterial',
                description: 'Material tank is contructed from',
            },
            image: {
                type: 'String',
                editable: true,
                label: 'Image',
                name: 'image',
                description: 'Photograph of tank',
            },
            comments: {
                type: 'String',
                editable: true,
                label: 'Comments',
                name: 'comments',
                description: 'Free text for info ',
            },
            date_of_last_filled: {
                type: 'Date',
            },
            volume_used_yesterday: {
                type: 'Number',
            },
            predicted_run_out_date: {
                type: 'Date',
            },
            total_volume: {
                type: 'Attribute',
                editable: false,
                actions: { edit: false },
                displayFn: () => this._totalVolume,
            },
            current_filled_volume: {
                type: 'Number',
            },
            height: {
                type: 'Number',
                editable: true,
                label: 'Height (m)',
                name: 'height',
                default: 0,
            },
            diameter: {
                type: 'Number',
                editable: true,
                label: 'Diameter (m)',
                name: 'diameter',
                default: 0,
            },
            circumference: {
                type: 'Attribute',
                editable: false,
                actions: { edit: false },
                displayFn: () => this._circumference,
            },
            tank_manufacturer: {
                type: 'String',
                validation: {
                    regex: /tank_manufacturer/i,
                    pass: false,
                    invalidMessage: 'Invalid input for a Tank Manufacturer',
                },
            },
            material: {
                type: 'String',
                validation: {
                    regex: /tank_material/i,
                    pass: false,
                    invalidMessage: 'Invalid input for a Tank material',
                },
            },
            tank_model: {
                type: 'String',
                validation: {
                    regex: /tank_model/i,
                    pass: false,
                    invalidMessage: 'Invalid input for a Tank Manufacturer',
                },
            },
            tank_type: {
                type: 'String',
                validation: {
                    regex: /tank_type/i,
                    pass: false,
                    invalidMessage: 'Invalid input for a Tank type',
                },
            },
            tank_use: {
                type: 'String',
                validation: {
                    regex: /tank_use/i,
                    pass: false,
                    invalidMessage: 'Invalid input for a Tank Usage',
                },
            },
            Tank_Group_Community: {
                type: 'String',
                validation: {
                    regex: /tank_use/i,
                    pass: false,
                    invalidMessage: 'Invalid input for a Tank Usage',
                },
            },
            year_of_manufacture: {
                type: 'Date',
                validation: {
                    regex: /\d\d\d\d/i,
                    pass: true,
                    invalidMessage: 'Year of manufacture must be a four digit year',
                },
            },
            no_of_users: {
                type: 'Number',
            },
            connecting_pipe_length: {
                type: 'Number',
            },
            connecting_pipe_diameter: {
                type: 'Number',
            },
            Alert: {
                type: 'Array',
                cardinality: {
                    out: null,
                    in: null,
                },
                actions: {
                    // create: false,
                    // link: false,
                    // delete: false
                    edit: true,
                },
            },
            Location: {
                type: 'Array',
                label: 'Tank',
                cardinality: {
                    out: 1,
                    in: null,
                },
            },
            Status: {
                type: 'Derived',
                label: 'Health',
                actions: {
                    create: false,
                    link: false,
                },
                valueFn: (state) => {
                    return {
                        Geofence: state.userView.Geofence,
                        shadow: this.shadow,
                        thing: this,
                    };
                },
                viewName: 'ThingPayloadData',
            },
            History_Charts: {
                type: 'Derived',
                actions: {
                    create: false,
                    link: false,
                },
                valueFn: () => {
                    return { currentThingHistory: this.history };
                },
                viewName: 'ThingHistoryCharts',
            },
            Picture: {
                type: 'Derived',
                actions: {
                    create: false,
                    link: false,
                },
                valueFn: () => {
                    return { presignedUrl: this.presignedUrl, type: this.type };
                },
                viewName: 'Picture',
            },
            Device: {
                type: 'Array',
                label: 'Monitoring Devices',
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
            UsageInDay: {
                type: 'Array',
                label: 'UsageInDay',
                cardinality: {
                    out: null,
                    in: null,
                },
                actions: {
                    edit: true,
                },
            },
            VolumeInPeriod: {
                type: 'Array',
                label: 'VolumeInPeriod',
                cardinality: {
                    out: null,
                    in: null,
                },
                actions: {
                    edit: true,
                },
            },
            ForecastCollection: {
                type: 'Array',
                label: 'ForecastCollection',
                cardinality: {
                    out: null,
                    in: null,
                },
                actions: {
                    edit: true,
                },
            },
            UsageInHour: {
                type: 'Array',
                label: 'UsageInHour',
                cardinality: {
                    out: null,
                    in: null,
                },
                actions: {
                    edit: true,
                },
            },
            YieldForecast: {
                type: 'Array',
                label: 'YieldForecast',
                cardinality: {
                    out: null,
                    in: null,
                },
                actions: {
                    edit: true,
                },
            },
            TankProductModel: {
                type: 'Array',
                label: 'ProductModel',
                cardinality: {
                    out: null,
                    in: 1,
                },
            },
        };
    }
    getLinkAttributes() {
        const functions = this.getUserAttributes().functions;
        return {
            ...super.getLinkAttributes(),
            functions,
        };
    }
}
exports.Tank = Tank;
Tank.aggregationFns = DefinitionAndHelpers_1.TankAggregationFns;
